import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  wrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  img: {
    height: 28,
    width: 'auto',
    borderRadius: 4,
    flexShrink: 0,
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.15,
    overflow: 'hidden',
  },
  company: {
    fontFamily: "'Red Hat Text', 'Helvetica Neue', sans-serif",
    fontSize: 10,
    fontWeight: 600,
    color: 'rgba(255, 255, 255, 0.62)',
    letterSpacing: '0.12em',
    textTransform: 'uppercase' as const,
    whiteSpace: 'nowrap' as const,
  },
  product: {
    fontFamily: "'Red Hat Display', 'Helvetica Neue', sans-serif",
    fontSize: 15,
    fontWeight: 700,
    color: '#ffffff',
    whiteSpace: 'nowrap' as const,
  },
});

const LogoFull = () => {
  const c = useStyles();
  return (
    <div className={c.wrap}>
      <img src="/favicon.ico" alt="Appointy" className={c.img} />
      <span className={c.stack}>
        <span className={c.company}>Appointy</span>
        <span className={c.product}>Developer Hub</span>
      </span>
    </div>
  );
};

export default LogoFull;
